import { Button } from "@/components/ui";

type ErrorFallbackProps = {
  error: Error;
  onReset: () => void;
};

export function ErrorFallback({ error, onReset }: ErrorFallbackProps) {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-3 bg-bg px-6 text-center">
      <h1 className="text-xl font-semibold text-fg">Something went wrong</h1>
      <p className="max-w-md text-sm text-fg-muted">{error.message}</p>
      <Button onClick={onReset}>Try again</Button>
    </div>
  );
}
